// @ts-strict-ignore
import { getIsApp } from '../../../../modules/AppInfo';
import {
  isAnonymous,
  ShareChannelFactory,
  ShareChannelMap,
  ShareProvider,
  ShareTarget,
  socialSharing,
} from '../../../../modules/share';
import { getProfileShareImage, getShareText } from './helpers';

type InstaShareParams = {
  text: string;
  image?: string;
};

// Note: Re-ported the following code to stay close to the original from socialShare.js
const handleShare = (
  params: InstaShareParams,
  onSuccess: () => void,
  onFail: (err: string) => void,
) => {
  if (getIsApp() && socialSharing()) {
    socialSharing().shareViaInstagram(params.text, params.image, onSuccess, onFail);
  }
};

const profileShare: ShareChannelFactory<ShareProvider | null> = (
  provider,
  url,
  user,
  onSuccess,
  onFail,
  message = {},
) => {
  let content: string;
  let isMine: boolean;
  if (provider) {
    isMine = !isAnonymous(user) && provider.id === user.provider_id;
    content = `Book an appointment online with ${provider.name} | StyleSeat at: ${url}`;
  } else {
    isMine = false;
    content = `Book an appointment online with StyleSeat | StyleSeat at: ${url}`;
  }

  const params: InstaShareParams = {
    text: getShareText(
      url,
      content,
      isMine,
      message.text,
    ),
    image: message.image || getProfileShareImage(provider),
  };

  return () => {
    handleShare(params, onSuccess, onFail);
  };
};

const MAP: ShareChannelMap = {
  [ShareTarget.PROFILE]: profileShare,
  [ShareTarget.SEARCH]: profileShare,
  [ShareTarget.PLATFORM]: profileShare,
};

export default MAP;
